exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".child_page[data-v-14456ffd]{padding:20px 30px}[data-v-14456ffd] .label_title{padding:10px 24px;background:#f5f5f5;margin-top:20px;margin-bottom:10px}[data-v-14456ffd] .label_title p{padding-left:12px;border-left:3px solid #2993ff;font-size:16px}[data-v-14456ffd] .list_item{width:50%;display:-webkit-box;display:-ms-flexbox;display:flex;margin-bottom:7px}[data-v-14456ffd] .list_item label{width:150px;text-align:right;line-height:35px}[data-v-14456ffd] .list_item>div,[data-v-14456ffd] .list_item>p{-webkit-box-flex:1;-ms-flex:1;flex:1;line-height:35px}\n", ""]);

// exports
